<div class="glass-house-header-quantity-and-price">
  <div class="glass-house-header-quantity">Quantity</div>
  <div class="glass-house-header-price">Price</div>
</div>
